import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import { LoaderPage, Btn, Respo } from '../../components'
import StepsContext from '../../contexts/StepsContext'
import { useYupValidation } from '../../hooks'
import useStep from '../../hooks/Steps/useSteps'
import { IValidationQuestions } from '../../interfaces'
import { postEmail } from '../../service'
import { validationQuestions } from '../../utils/schemas/validationQuestions'
import { useAppDispatch } from '../../hooks/reducer/hooks'
import { setAnswers } from '../../redux/questionSlicer'
import { EmailData } from '../../interfaces/EmailData'
import { IBrandForm } from '../../interfaces'
import calculateAnswers from '../../utils/calculateAnswers'

export default function Stepper(): React.ReactElement {
	const queryParams = new URLSearchParams(useLocation().search)

	const { steps, currentQuestion, currentStep } = useContext(StepsContext)
	const [isError, setIsError] = useState(false) // CONTROLE DE ERRO DA PAGINA
	const { nextStep, returnStep } = useStep()
	const navigate = useNavigate()
	const [msgError, setMsgError] = useState(false)
	const [questId, setQuestId] = useState<string>(steps[currentStep].questions[currentQuestion]._id)
	const [questResponse, setQuestResponse] = useState(undefined)
	const { watch, control, setValue, handleSubmit, getValues } = useForm<IValidationQuestions>({
		resolver: useYupValidation(validationQuestions(steps)),
	})

	const allValues = watch()

	const dispatch = useAppDispatch()

	function verifyErrors(): boolean {
		if (getValues(`${steps[currentStep].name}.questions.${steps[currentStep].questions[currentQuestion]._id}`) === undefined) {
			setMsgError(true)
			return true
		}
		setMsgError(false)
		return false
	}

	useEffect(() => {
		Object.entries(steps).forEach(item => {
			setValue(`${item[1].name}._id`, item[1]._id)
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [steps])
	// ENVIA PRO BACK
	async function submit(body: IValidationQuestions): Promise<void> {
		try {
			if (currentQuestion === 4) {
				dispatch(setAnswers(body))
				localStorage.setItem('userAnswers', JSON.stringify(body))
				sendEmail(body)
				navigate('/resultado')
			}
		} catch (e) {
			setIsError(true)
		}
	}

	function quizz(): void {
		window.location.reload()
	}
	function sendEmail(body: IValidationQuestions): void {
		const userValuesJson = localStorage.getItem('userValues')
		let response = calculateAnswers(body)
		if (userValuesJson) {
			const userValues = JSON.parse(userValuesJson) as IBrandForm
			const emailData: EmailData = {
				userValues,
				traficValues: {
					traffic_source: queryParams.get('utm_source'),
					traffic_medium: queryParams.get('utm_medium'),
					traffic_campaign: queryParams.get('utm_campaign'),
					traffic_value: queryParams.get('utm_term'),
				},
				userAnwsers: response.answers,
				totalPoints: response.totalPoints,
			}

			postEmail(emailData)
		}
	}
	// algo esta errado ?
	useEffect(() => {
		setQuestId(steps[currentStep].questions[currentQuestion]._id)
		setQuestResponse(allValues[`${steps[currentStep].name}`]?.questions[questId])
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentQuestion, questId])
	return (
		<>
			{isError ? (
				<LoaderPage
					error={isError}
					retry={() => {
						quizz()
					}}
				/>
			) : (
				<div>
					<div>
						<div className="container-mobile btn-top">
							<div className="title-step">
								<p>{steps[currentStep].name}</p>
							</div>
							<div
								style={{
									display: 'flex',
									flexWrap: 'wrap',
									gap: '0.5rem',
									marginTop: '1.5rem',
								}}
							>
								{steps[currentStep].questions.map((q, index) => (
									<div
										key={`question-bar-${q._id}`}
										style={{
											marginTop: '1rem',
											flexGrow: 1,
											height: '0.3rem',
											transition: '0.6s',
											minWidth: '3.125 rem',
											backgroundColor: index > currentQuestion ? '#CDCDCD ' : '#0091E7',
										}}
									/>
								))}
							</div>
						</div>
					</div>
					<form onSubmit={handleSubmit(submit)} className="form">
						{steps.length > 0 ? (
							<div className="questions">
								<h1 className="question">{steps[currentStep].questions[currentQuestion].question}</h1>
							</div>
						) : (
							<> </>
						)}
						{steps.length ? (
							<Controller
								control={control}
								key={`response${steps[currentStep].questions[currentQuestion]._id}`}
								name={`${steps[currentStep].name}.questions.${steps[currentStep].questions[currentQuestion]._id}`}
								render={({ field: { onChange } }) => {
									return (
										<Respo
											defaultValue={questResponse}
											setRadio={onChange}
											setValue={setQuestResponse}
											switchAmount={5}
											titles={['Discordo Totalmente', 'Talvez', 'Concordo Totalmente']}
										/>
									)
								}}
							/>
						) : null}

						{msgError && (
							<div className="center">
								<p className="msg-error">Selecione alguma alternativa acima</p>
							</div>
						)}

						<div className="navigation">
							{currentStep + 1 === steps.length && steps[currentStep].questions.length === currentQuestion + 1 ? (
								<>
									<div className="navigation__buttons">
										<Btn
											left={<img src="/assets/img/outhers/arrow-return.png" alt="Retornar" title="Retornar" />}
											placeholder="Voltar"
											variant="arrows"
											width="7rem"
											height="2.938rem"
											onClick={() => returnStep()}
										/>
									</div>
									<div className="btn-result">
										<Btn
											placeholder="Ver meu resultado"
											width="12.625rem"
											height="2.938 rem"
											type="submit"
											onClick={() => verifyErrors()}
										/>
									</div>
								</>
							) : (
								<div className="navigation__buttons">
									<Btn
										left={<img src="/assets/img/outhers/arrow-return.png" alt="Retornar" title="Retornar" />}
										placeholder="Voltar"
										variant="arrows"
										width="7rem"
										height="2.938rem"
										onClick={() => returnStep()}
									/>
									<Btn
										placeholder="Próximo"
										type="button"
										variant="arrows"
										width="7.5rem"
										height="2.938rem"
										onClick={() => {
											const hasError = verifyErrors()
											if (!hasError) nextStep()
										}}
										right={<img src="/assets/img/outhers/arrow-next.png" alt="Próximo" title="Próximo" />}
									/>
								</div>
							)}
						</div>
					</form>
					<br />
				</div>
			)}
		</>
	)
}
